/* <pdp-sticky-bar>: the product summary bar that slides in once the main
   Add to Cart row has scrolled out of view above the viewport.

   Its buttons submit the main product form through the form attribute, so
   product-form.js handles them exactly like the main pair. Its quantity
   stepper mirrors the main one in both directions. */
class PdpStickyBar extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.anchor = document.getElementById(`ProductSubmit-${this.sectionId}`);
    this.source = document.getElementById(`Quantity-${this.sectionId}`);
    this.mirror = this.querySelector('[data-quantity-mirror]');
    this.setVisible(false);

    if (this.source && this.mirror) {
      this.mirror.value = this.source.value;
      this.source.addEventListener('change', () => (this.mirror.value = this.source.value));
      this.source.addEventListener('input', () => (this.mirror.value = this.source.value));
      const push = () => {
        this.source.value = this.mirror.value;
        this.source.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.mirror.addEventListener('change', push);
      this.mirror.addEventListener('input', push);
    }

    if (!this.anchor || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(([entry]) => {
      this.setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    this.observer.observe(this.anchor);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  setVisible(visible) {
    this.classList.toggle('is-visible', visible);
    this.toggleAttribute('inert', !visible);
    this.setAttribute('aria-hidden', String(!visible));
    document.body.classList.toggle('has-pdp-sticky', visible);
  }
}
customElements.define('pdp-sticky-bar', PdpStickyBar);
